import { Stack } from "@mui/material";
import { FC } from "react";
import { useWorkspaceStore } from "../../../../store/workspace/WorkspaceStore";
import { ICPSAMDisplay } from "./ICPSAMDisplay";
import { ICPSOMDisplay } from "./ICPSOMDisplay";

/**
 * Section component that displays SAM and SOM data
 */
export const ICPSAMSOMSection: FC = () => {
  const icpSAM = useWorkspaceStore((state) => state.icpSAM);
  const icpSOM = useWorkspaceStore((state) => state.icpSOM);

  if (!icpSAM && !icpSOM) {
    return null;
  }

  return (
    <Stack direction="row" gap={2} sx={{ marginBottom: 3 }}>
      <ICPSAMDisplay />
      <ICPSOMDisplay />
    </Stack>
  );
};
